/**
 * Strips a trailing slash for route-matching purposes, since the router treats `/landing` and
 * `/landing/` as equivalent but a plain string comparison does not.
 *
 * Used by `src/routes/layout.tsx` to decide which route shows the campaign promo bar and the
 * home campaign banner.
 *
 * The root path is left alone: `''.length > 1` is false, and a bare `/` has nothing to strip.
 *
 * `|| '/'` catches `//`, which strips to the empty string and would then match nothing. That
 * matters now the root itself is a matched route (FAAS-909).
 */
export const normalisePathname = (pathname: string): string =>
  pathname.length > 1 ? pathname.replace(/\/+$/, '') || '/' : pathname
